import React from "react"

import { logToServer } from "../../../../ErrorBoundary"
import { getFormattedMessage } from "../../../shared_components_registration"
import ReactSelectionElement from "../../../../shared_components/widgets/ReactSelectionElement"

export const handleError = async (err, setErr) => {
  logToServer(err)
  console.error(err)
  const generalErr = getFormattedMessage("general.server.error", "Error! Could not process request")

  try {
    if (err?.json) {
      const data = await err.json()
      let error = ""
      Object.entries(data).forEach(([key, value], idx) => {
        error = `${error}${idx > 0 ? "; " : ""}${key}: ${value}`
      })
      setErr(error || generalErr)
    } else {
      setErr(generalErr)
    }
  } catch (parseErr) {
    console.error("Failed to parse error response:", parseErr)
    setErr(generalErr)
  }
}

export const ActiveSpan = ({ active, getTextStr }) => (
  <>
    <b>
      {active ? (
        <span className={"text-success"}>{getTextStr("general.active", "Active")}</span>
      ) : (
        <span className={"text-danger"}>{getTextStr("general.inactive", "Inactive")}</span>
      )}
    </b>
  </>
)

export const UserDropdown = ({
  field,
  label,
  current = {},
  setValue,
  options = [],
  isClearable = false,
  required = true,
  returnObj = false,
  disabled = false,
}) => {
  const defaultOpt = options.find((o) => o?.value?.id === current?.id)
  return (
    <ReactSelectionElement
      name={field}
      list={options}
      defaultValue={defaultOpt}
      getOptionLabel={(obj) => obj.label}
      onValueChange={(_, selected) => setValue(field, returnObj ? selected?.value : selected?.value?.id)}
      isClearable={isClearable}
      isMulti={false}
      required={required}
      label={label}
      disabled={disabled}
    />
  )
}

const getStatusObj = (status) => ({
  value: status.value,
  label: getFormattedMessage(status.id, status.msg, true),
})
export const statusOptions = [
  { id: "general.active", msg: "Active", value: true },
  { id: "general.inactive", msg: "Inactive", value: false },
]
export const StatusDropdown = ({
  showLabel = false,
  options,
  defaultValue,
  setValue,
  prefix,
  disabled = false,
}) => {
  return (
    <ReactSelectionElement
      list={options.map((o) => getStatusObj(o))}
      defaultValue={getStatusObj(defaultValue)}
      getOptionLabel={(obj) => obj.label}
      onValueChange={(_, selected) => setValue(selected?.value)}
      disabled={disabled}
      isClearable={false}
      isMulti={false}
      required={false}
      {...(showLabel
        ? { label: `${prefix ? `${prefix} ` : ""}${getFormattedMessage("general.status", "Status", true)}` }
        : {})}
    />
  )
}
